<template lang="pug">
app-expansion-panels(
  flat
  filled
  accordion
)
  template(v-for="nomination in nominations")
    expansion-nomination(
      :key="nomination.id"
      v-model="formData[nomination.id]"
      :nomination="nomination"
      :fields="fields"
      :event="event"
    )
</template>

<script>
import AppExpansionPanels from '@/components/user-redesign/expansion-panels/AppExpansionPanels.vue';
import ExpansionNomination from './ExpansionNomination.vue';

export default {
  components: {
    AppExpansionPanels,
    ExpansionNomination,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    eventFields: {
      type: Array,
      required: true,
    },
    nominations: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      bufferValue: {},
      formData: this.value,
    };
  },
  computed: {
    fields() {
      const nominationsIds = this.nominations.map(({ id }) => id);

      return this.eventFields
        .filter(({ nomination_id }) => nominationsIds.includes(nomination_id))
        .toSorted((a, b) => a.nomination_id - b.nomination_id);
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
};
</script>
